import { createFileRoute } from "@tanstack/react-router";
import { blogRouteOptions } from "@/components/blog/blogRouteOptions";

export const Route = createFileRoute("/ai-overviews-what-changed-in-search-2026")(blogRouteOptions("ai-overviews-what-changed-in-search-2026"));
